import { useContext } from 'react'

import { MODALS_ID } from '../../../constants'

import { ModalContext } from '../../../provider/ModalProvider'

import { CenterItem } from '../../../components/common'
import { Button } from '../../../components/button'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text'

import { ReactComponent as ExclamationIcon } from '../../../assets/gui/exclamation_60.svg'

export function MismatchUserModal() {
  const { closeModal } = useContext(ModalContext)

  const close = () => closeModal(MODALS_ID.MISMATCH_USER)

  return (
    <Modal id={MODALS_ID.MISMATCH_USER}>
      <CenterItem $direction="column" $gap={16}>
        <ExclamationIcon />
        <Text size={16} weight={500} block={true} $textAlign="center">
          본인 명의의 휴대폰 명의만 등록 가능합니다.
        </Text>
      </CenterItem>
      <Modal.Footer>
        <Button onClick={close}>확인</Button>
      </Modal.Footer>
    </Modal>
  )
}
